import {useGetApi} from 'common/hooks/useGetApi';
import {useEffect} from 'react';

const useDictionary = <T>(url: string) => {
   const {state, request, loading} = useGetApi<T>(url);

   useEffect(() => {
      if (state || loading) return;
      request();
   }, [state, request]);

   return {state, request, loading};
};

export default useDictionary;
